// source: witbooking/backoffice/emailconfig/v1/emailconfig_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.emailconfig.v1.EmailConfig', null, global);
goog.exportSymbol('proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.displayName = 'proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.displayName = 'proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.displayName = 'proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.displayName = 'proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.emailconfig.v1.EmailConfig.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.emailconfig.v1.EmailConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.emailconfig.v1.EmailConfig.displayName = 'proto.witbooking.backoffice.emailconfig.v1.EmailConfig';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailconfig: (f = msg.getEmailconfig()) && proto.witbooking.backoffice.emailconfig.v1.EmailConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest;
  return proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.emailconfig.v1.EmailConfig;
      reader.readMessage(value,proto.witbooking.backoffice.emailconfig.v1.EmailConfig.deserializeBinaryFromReader);
      msg.setEmailconfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailconfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.emailconfig.v1.EmailConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EmailConfig emailConfig = 1;
 * @return {?proto.witbooking.backoffice.emailconfig.v1.EmailConfig}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.prototype.getEmailconfig = function() {
  return /** @type{?proto.witbooking.backoffice.emailconfig.v1.EmailConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.emailconfig.v1.EmailConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.emailconfig.v1.EmailConfig|undefined} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} returns this
*/
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.prototype.setEmailconfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.prototype.clearEmailconfig = function() {
  return this.setEmailconfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest.prototype.hasEmailconfig = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse;
  return proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest;
  return proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailconfig: (f = msg.getEmailconfig()) && proto.witbooking.backoffice.emailconfig.v1.EmailConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse;
  return proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.emailconfig.v1.EmailConfig;
      reader.readMessage(value,proto.witbooking.backoffice.emailconfig.v1.EmailConfig.deserializeBinaryFromReader);
      msg.setEmailconfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailconfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.emailconfig.v1.EmailConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional EmailConfig emailConfig = 1;
 * @return {?proto.witbooking.backoffice.emailconfig.v1.EmailConfig}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.prototype.getEmailconfig = function() {
  return /** @type{?proto.witbooking.backoffice.emailconfig.v1.EmailConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.emailconfig.v1.EmailConfig, 1));
};


/**
 * @param {?proto.witbooking.backoffice.emailconfig.v1.EmailConfig|undefined} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse} returns this
*/
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.prototype.setEmailconfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.prototype.clearEmailconfig = function() {
  return this.setEmailconfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.prototype.hasEmailconfig = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.emailconfig.v1.EmailConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailsReservationReceiversList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    languageHotelEmail: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fromName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fromEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
    withConditions: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    withRateSpecification: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    withAgent: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    replyTo: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.emailconfig.v1.EmailConfig;
  return proto.witbooking.backoffice.emailconfig.v1.EmailConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmailsReservationReceivers(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguageHotelEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromEmail(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithConditions(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithRateSpecification(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithAgent(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplyTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.emailconfig.v1.EmailConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailsReservationReceiversList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getLanguageHotelEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFromName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFromEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWithConditions();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getWithRateSpecification();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getWithAgent();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getReplyTo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * repeated string emails_reservation_receivers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getEmailsReservationReceiversList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setEmailsReservationReceiversList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.addEmailsReservationReceivers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.clearEmailsReservationReceiversList = function() {
  return this.setEmailsReservationReceiversList([]);
};


/**
 * optional string language_hotel_email = 2;
 * @return {string}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getLanguageHotelEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setLanguageHotelEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string from_name = 3;
 * @return {string}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getFromName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setFromName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string from_email = 4;
 * @return {string}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getFromEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setFromEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool with_conditions = 5;
 * @return {boolean}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getWithConditions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setWithConditions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool with_rate_specification = 6;
 * @return {boolean}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getWithRateSpecification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setWithRateSpecification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool with_agent = 7;
 * @return {boolean}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getWithAgent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setWithAgent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string reply_to = 8;
 * @return {string}
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.getReplyTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.emailconfig.v1.EmailConfig} returns this
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfig.prototype.setReplyTo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.emailconfig.v1);
